import React from "react";

import { Context, ShowcaseBlock, StandaloneShowcaseBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { MediaChooserBlock } from "../MediaChooserBlock";
import { ThemedModule, getThemeClass } from "../ThemedModule";

import styles from "./Showcase.module.scss";

export const Showcase = ({
    value,
    className,
}: {
    value: ShowcaseBlock | StandaloneShowcaseBlock;
    className?: string;
}) => {
    const width = "width" in value && value.width ? value.width : "center";
    return (
        <figure
            className={concatClassNames([
                styles[width],
                getThemeClass(value.module_theme),
                className,
            ])}
        >
            {value.media && (
                <MediaChooserBlock
                    attrs={{
                        className: value.media_aspect_ratio
                            ? styles[value.media_aspect_ratio]
                            : undefined,
                    }}
                    value={value.media}
                />
            )}
            {value.caption && (
                <figcaption className={styles.caption}>
                    {value.caption}
                </figcaption>
            )}
        </figure>
    );
};

export const StandaloneShowcase = ({
    value,
}: {
    value: StandaloneShowcaseBlock;
}) => (
    <ThemedModule theme={value.module_theme}>
        <Showcase value={value} />
    </ThemedModule>
);

export const AnimatedShowcase = () => {
    const gifSrc = React.useContext(Context).core_assets.lig_animation;

    return (
        <Showcase
            value={{
                media_aspect_ratio: "banner",
                media: [
                    {
                        type: "image",
                        value: {
                            title: "lig-animation",
                            description:
                                "stylized girl animating - she springs up!",
                            default_alt_text:
                                "stylized girl animating - she springs up!",
                            width: 1313,
                            height: 525,
                            brightness: 213,
                            url: gifSrc,
                            renditions: {
                                original: {
                                    spec: "original",
                                    width: 1313,
                                    height: 525,
                                    url: gifSrc,
                                    size: 0,
                                    mimetype: "image/gif",
                                },
                            },
                            imageData: null,
                        },
                        id: "928e3b70-f2aa-4740-8743-777a5802195a",
                    },
                ],
                caption: "",
                width: "full",
                module_theme: "lilac",
            }}
        />
    );
};
